import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

export const FlexibleDropCont = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const DropChildrenCont = styled.div`
  position: relative;
`;

interface IFlexBodyCont {
  theme: ITheme;
  width?: string;
  anchor: 'top' | 'bottom';
  positionX?: string;
  positionY?: string;
}

export const FlexBodyCont = styled.div<IFlexBodyCont>`
  position: absolute;
  min-height: 48px;
  max-height: 240px;
  overflow: auto;
  border-radius: 8px;
  z-index: 1000;

  ${({ theme, positionX, positionY, width, anchor }: IFlexBodyCont) => `
      left: ${positionX || '0'};
      background: ${theme.colors.neutral.primary[0]};
      border: 1px solid ${theme.colors.neutral.primary[30]};
      width: ${width || '264px'};

      ${
  anchor === 'top'
    ? `
        bottom: ${positionY || '48px'};
      `
    : ''
};
      ${
  anchor === 'bottom'
    ? `
        top: ${positionY || '48px'};
      `
    : ''
};
    `}
`;
